import React from 'react';
import { FaQuestionCircle } from 'react-icons/fa';
import './FaqHero.css';

const FaqHero = () => {
    return (
        <section className="_fHSec_y7Z_">
            <div className="_fHCnt_z8A_">
                <div className="_hIWrap_a9B_">
                    <FaQuestionCircle className="_hIcon_b0C_" />
                </div>
                <h1 className="_hTitle_c1D_ _hTitle_s5E_ workflow-title">Frequently Asked Questions</h1>
                <p className="_hSub_d2E_">
                    Find answers to common questions about shopping, selling and partnering with Vanidya.
                    Whether you’re a customer, a seller or represent a group, we’re here to help.
                </p>
            </div>
        </section>
    );
};

export default FaqHero;